import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import FileUploadBox from "./components/FileUploadBox";
import DraggableSelectList from "./quizSystem/questionsSection/components/QuestionListDropdown";
import { useSelector, useDispatch } from "react-redux";
import { fetchActiveQuestions } from "../store/reducers/questionsSectionSlice";

const ClientType = [
  { value: "Business", label: "Business" },
  { value: "Sport", label: "Sport" },
  { value: "Private", label: "Private" },
];

const Purpose = [
  { value: "First Aid", label: "First Aid" },
  { value: "Emergency Service", label: "Emergency Service" },
  { value: "Cyber", label: "Cyber" },
  { value: "Machines", label: "Machines" },
];

const Lang = [
  { value: "Danish", label: "Danish" },
  { value: "English", label: "English" },
];

const Format = [
  { value: "A6", label: "A6" },
  { value: "A7", label: "A7" },
  { value: "Tailored", label: "Tailored" },
];

const Standard = [
  { value: "Standard", label: "Standard" },
  { value: "Tailored", label: "Tailored" },
];

const Country = [
  { value: "Denmark", label: "Denmark" },
  { value: "US", label: "US" },
  { value: "UK", label: "UK" },
  { value: "Canada", label: "Canada" },
  { value: "Australia", label: "Australia" },
  { value: "South Africa", label: "South Africa" },
  { value: "New Zealand", label: "New Zealand" },
];

const AddSingleActionCard = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { search } = useLocation();
  const paramIdSeprator = (param) => {
    const paramId = param.split("=");
    return paramId[1];
  };
  const [countrys, setCountrys] = useState(Country[0]);
  const [clientTypes, setClientTypes] = useState(ClientType[0]);
  const [standards, setStandards] = useState(Standard[0]);
  const [formats, setFormats] = useState(Format[0]);
  const [purposes, setPurposes] = useState(null);
  const [langs, setLangs] = useState(Lang[0]);
  const [remark, setRemark] = useState("");
  const [versionNumber, setVersionNumber] = useState(0);
  const [pdfData, setPdfData] = useState([]);
  const [ac_no, setAc_no] = useState();
  const [files, setFiles] = useState([]);
  const [engName, setEngName] = useState("");
  const [engShortName, setEngShortName] = useState("");
  const [danishName, setDanishName] = useState("");
  const [danishShortName, setDanishShortName] = useState("");
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [data, setData] = useState({
    english_name: [],
    english_short_name: [],
    danish_name: [],
    danish_short_name: [],
    client_type: [],
    target_company: [],
    format: [],
    purpose_type: [],
    language: [],
    standard_or_tailored: [],
    ac_document: [],
    remarks: [],
    version: 0,
  });

  const [options, setOptions] = useState([]);
  const [selectedQuestionIds, setSelectedQuestionIds] = useState([]);
  const [defaultQuestionIds, setDefaultQuestionIds] = useState([]);
  const { activeQuestions } = useSelector((state) => state.questions);

  useEffect(() => {
    dispatch(fetchActiveQuestions());
  }, [dispatch]);

  useEffect(() => {
    if (activeQuestions) {
      const formatted = activeQuestions.map((q) => ({
        label: q.question,
        value: q.id,
      }));

      setOptions(formatted);
    }
  }, [activeQuestions]);

  const handleSelectedIds = (ids) => {
    setSelectedQuestionIds(ids);
  };

  // get api
  const jwtToken = localStorage.getItem("jwt_token");
  const Single = async () => {
    let url = `${process.env.REACT_APP_API_URL}/actioncard`;
    fetch(url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data.actioncard_details;
        // console.log(codeMessage);
        if (codeMessage) {
          const initialData = {
            client_type: [],
            target_company: [],
            format: [],
            purpose_type: [],
            language: [],
            standard_or_tailored: [],
            ac_document: [],
            remarks: [],
            version: 0,
          };
          codeMessage.map((one) => {
            one.client_type &&
              initialData.client_type.push({
                label: one.client_type,
                value: one.client_type,
              });
            one.target_company &&
              initialData.target_company.push({
                label: one.target_company,
                value: one.target_company,
              });
            one.format &&
              initialData.format.push({
                label: one.format,
                value: one.format,
              });
            one.purpose_type &&
              initialData.purpose_type.push({
                label: one.purpose_type,
                value: one.purpose_type,
              });
            one.language &&
              initialData.language.push({
                label: one.language,
                value: one.language,
              });
            one.standard_or_tailored &&
              initialData.standard_or_tailored.push({
                label: one.standard_or_tailored,
                value: one.standard_or_tailored,
              });
            one.ac_document &&
              initialData.ac_document.push({
                label: one.ac_document,
                value: one.ac_document,
              });
            one.remarks &&
              initialData.remarks.push({
                label: one.remarks,
                value: one.remarks,
              });
            initialData.version = one.version;
          });
          setData(initialData);
        }
      });
  };
  //
  useEffect(() => {
    Single();
    AcNumberInAddData();
    const id = paramIdSeprator(search);
    if (id) {
      update(id);
    }
  }, []);
  // post api for unit
  const postDataApi = async () => {
    let url = `${process.env.REACT_APP_API_URL}/actioncard`;
    const bodyFormData = new FormData();

    const returnLabel = (arr) => arr.map((one) => one.label);
    const appendPdfField = (key, value) => {
      if (!value) {
        bodyFormData.append(key, "none");
        return;
      }

      bodyFormData.append(key, value);
    };

    bodyFormData.append("english_name", engName);
    bodyFormData.append("english_short_name", engShortName);
    bodyFormData.append("danish_name", danishName);
    bodyFormData.append("danish_short_name", danishShortName);

    bodyFormData.append(
      "client_type",
      JSON.stringify(
        Array.isArray(clientTypes)
          ? returnLabel(clientTypes)
          : [clientTypes.label]
      )
    );

    bodyFormData.append(
      "target_country",
      JSON.stringify(
        Array.isArray(countrys) ? returnLabel(countrys) : [countrys.label]
      )
    );

    bodyFormData.append(
      "format",
      JSON.stringify(
        Array.isArray(formats) ? returnLabel(formats) : [formats.label]
      )
    );

    bodyFormData.append("purpose_type", purposes?.label || "");

    bodyFormData.append(
      "language",
      JSON.stringify(Array.isArray(langs) ? returnLabel(langs) : [langs.label])
    );

    bodyFormData.append("standard_or_tailored", standards?.label);
    bodyFormData.append("version", versionNumber);
    bodyFormData.append("remarks", remark);
    bodyFormData.append("ac_no", ac_no);

    // ✅ FILES
    files.forEach((file) => bodyFormData.append("ac_document", file));

    appendPdfField("front_pdf", frontFile);
    appendPdfField("back_pdf", backFile);

    // ✅ QUESTIONS FIX
    bodyFormData.append("question_ids", JSON.stringify(selectedQuestionIds));

    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      body: bodyFormData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) toast.error(data.error);
        else {
          toast.success("Data Added");
          history.push("/single-action");
        }
      });
  };
  // get api
  //
  const id = paramIdSeprator(search);
  const update = async (id) => {
    let url = `${process.env.REACT_APP_API_URL}/actioncard/${id}`;
    fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data.actioncard_details;
        setPdfData(codeMessage.version_pdf_file);
        setEngName(codeMessage.english_name);
        setEngShortName(codeMessage.english_short_name);
        setDanishName(codeMessage.danish_name);
        setDanishShortName(codeMessage.danish_short_name);
        setRemark(codeMessage.remarks);
        setVersionNumber(codeMessage.version);
        setStandards({
          label: codeMessage.standard_and_tailored,
          value: codeMessage.standard_and_tailored,
        });
        const filteredClientData = ClientType.filter((one) => {
          return codeMessage.client_type.includes(one.label);
        });
        const filteredCountry = Country.filter((one) => {
          return codeMessage.target_company.includes(one.label);
        });
        const filteredFormate = Format.filter((one) => {
          return codeMessage.format.includes(one.label);
        });
        const filteredLen = Lang.filter((one) => {
          return codeMessage.language.includes(one.label);
        });
        // client_type
        setClientTypes(filteredClientData);
        // target_company
        setCountrys(filteredCountry);
        // formats
        setFormats(filteredFormate);
        // purpose_type
        // language
        setLangs(filteredLen);
        setPurposes(
          codeMessage.purpose_type
            ? {
                label: codeMessage.purpose_type,
                value: codeMessage.purpose_type,
              }
            : null
        );
        setAc_no(codeMessage.ac_no);
        if (codeMessage.question_ids) {
          const ids = Array.isArray(codeMessage.question_ids)
            ? codeMessage.question_ids
            : JSON.parse(codeMessage.question_ids);

          setSelectedQuestionIds(ids);
          setDefaultQuestionIds(ids);
        }
        setFrontFile(codeMessage.front_pdf);
        setBackFile(codeMessage.back_pdf);
      });
  };
  // update data
  const UpdateDataApi = async () => {
    const id = paramIdSeprator(search);
    let url = `${process.env.REACT_APP_API_URL}/actioncard/${id}`;

    const bodyFormData = new FormData();
    const returnLabel = (arr) => arr.map((one) => one.label);
    const appendPdfField = (key, value) => {
      if (!value) {
        bodyFormData.append(key, "none");
        return;
      }

      bodyFormData.append(key, value);
    };

    bodyFormData.append("english_name", engName);
    bodyFormData.append("english_short_name", engShortName);
    bodyFormData.append("danish_name", danishName);
    bodyFormData.append("danish_short_name", danishShortName);

    bodyFormData.append(
      "client_type",
      JSON.stringify(
        Array.isArray(clientTypes)
          ? returnLabel(clientTypes)
          : [clientTypes.label]
      )
    );

    bodyFormData.append(
      "target_country",
      JSON.stringify(
        Array.isArray(countrys) ? returnLabel(countrys) : [countrys.label]
      )
    );

    bodyFormData.append(
      "format",
      JSON.stringify(
        Array.isArray(formats) ? returnLabel(formats) : [formats.label]
      )
    );

    bodyFormData.append("purpose_type", purposes?.label || "");

    bodyFormData.append(
      "language",
      JSON.stringify(Array.isArray(langs) ? returnLabel(langs) : [langs.label])
    );

    bodyFormData.append("standard_or_tailored", standards?.label);
    bodyFormData.append("version", versionNumber);
    bodyFormData.append("remarks", remark);
    bodyFormData.append("ac_no", ac_no);

    // ✅ FILES (ONLY IF UPDATED)
    files.forEach((file) => bodyFormData.append("ac_document", file));

    appendPdfField("front_pdf", frontFile);
    appendPdfField("back_pdf", backFile);

    // ✅ QUESTIONS FIX (MISSING BEFORE)
    bodyFormData.append("question_ids", JSON.stringify(selectedQuestionIds));

    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      body: bodyFormData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) toast.error(data.error);
        else {
          toast.success("Data Updated Successfully");
          history.push("/single-action");
        }
      });
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (search) {
      UpdateDataApi();
    } else {
      postDataApi();
    }
  };

  const AcNumberInAddData = async () => {
    let url = `${process.env.REACT_APP_API_URL}/ac-number`;
    await fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data;
        setAc_no(codeMessage);
      });
  };
  return (
    <>
      <h4>{paramIdSeprator(search) ? "Update" : "Add"} ActionCard</h4>

      <form onSubmit={onSubmitHandler}>
        {/* AC NO */}
        <div className="row mb-3 align-items-center">
          <label className="col-md-2 col-form-label">AC No</label>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              value={ac_no}
              onChange={(e) => setAc_no(e.target.value)}
            />
          </div>
        </div>
        <hr style={{ color: "red" }} />

        {/* English & Danish Name */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label>English Name</label>
            <input
              className="form-control"
              value={engName}
              onChange={(e) => setEngName(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label>Danish Name</label>
            <input
              className="form-control"
              value={danishName}
              onChange={(e) => setDanishName(e.target.value)}
            />
          </div>
        </div>

        {/* Short Names */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label>Short English Name</label>
            <input
              className="form-control"
              value={engShortName}
              onChange={(e) => setEngShortName(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label>Short Danish Name</label>
            <input
              className="form-control"
              value={danishShortName}
              onChange={(e) => setDanishShortName(e.target.value)}
            />
          </div>
        </div>

        {/* Client Type & Remarks */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label>Client Type</label>
            <Select
              isMulti
              value={clientTypes}
              options={ClientType}
              onChange={setClientTypes}
            />
          </div>
          <div className="col-md-6">
            <label>Remarks</label>
            <textarea
              className="form-control"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <label>Purpose Type</label>
            <Select
              value={purposes}
              options={Purpose}
              onChange={setPurposes}
              isClearable
            />
          </div>
        </div>

        <hr style={{ color: "red" }} />
        {/* Target Country & Standard/Version */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label>Target Country</label>
            <Select
              isMulti
              value={countrys}
              options={Country}
              onChange={setCountrys}
            />
          </div>

          <div className="col-md-4">
            <label>Standard/Tailored</label>
            <Select
              value={standards}
              options={Standard}
              onChange={setStandards}
            />
          </div>

          <div className="col-md-4">
            <label>Version</label>
            <input
              type="text"
              className="form-control"
              value={versionNumber}
              onChange={(e) => setVersionNumber(e.target.value)}
            />
          </div>
        </div>

        <hr style={{ color: "red" }} />
        {/* PDFs */}
        <div className="row mb-3">
          <div className="col-12 col-md-6 mb-3">
            <FileUploadBox
              label="Front PDF"
              file={frontFile}
              setFile={setFrontFile}
              inputId="frontFileInput"
            />
          </div>

          <div className="col-12 col-md-6 mb-3">
            <FileUploadBox
              label="Back PDF"
              file={backFile}
              setFile={setBackFile}
              inputId="backFileInput"
            />
          </div>
        </div>
        <hr style={{ color: "red" }} />

        <label>Select Questions: </label>
        <DraggableSelectList
          options={options}
          defaultValues={defaultQuestionIds}
          onChange={handleSelectedIds}
        />
        <hr style={{ color: "red" }} />

        {/* SUBMIT BUTTON */}
        <div className="text-center">
          <button type="submit" className="btn bg_color px-4">
            {paramIdSeprator(search) ? "Update" : "Add"}
          </button>
        </div>
      </form>
    </>
  );
};

export default AddSingleActionCard;
